import { ResultsSearchRow } from "app/pages/sales-intelligence/common-components/search-results-table";
import IsNewOnlyCheckboxContainer from "app/pages/sales-intelligence/modules/advanced-search-filtering/containers/IsNewOnlyCheckbox/IsNewOnlyCheckboxContainer";
import { useAppsSearchText } from "app/pages/sales-intelligence/modules/apps-search/hooks/useAppsSearchText";
import appsSearchI18nKeys from "app/pages/sales-intelligence/modules/apps-search/utils/i18n";
import type { Translatable } from "app/pages/sales-intelligence/types";

const PLACEHOLDER: Translatable = {
    key: appsSearchI18nKeys.searchTextPlaceholder,
};

type Props = {
    areTableActionsDisabled: boolean;
};

const AppsTableSearchRowContainer = ({ areTableActionsDisabled }: Props) => {
    const { searchText, onSearchTextChange, onSearchTextClear } = useAppsSearchText();

    return (
        <ResultsSearchRow
            searchText={searchText}
            placeholder={PLACEHOLDER}
            isDisabled={areTableActionsDisabled}
            onSearch={onSearchTextChange}
            onSearchClear={onSearchTextClear}
        >
            <IsNewOnlyCheckboxContainer isDisabled={areTableActionsDisabled} />
        </ResultsSearchRow>
    );
};

export default AppsTableSearchRowContainer;
